export default class Search {
	constructor() {
		if (document.body.classList.contains("blog")) {
			this.productSearch = document.querySelector(".dgwt-wcas-search-input");
			this.events();
		}
	}

	events() {
		this.productSearch.value = "";
	}
}
